import { connect } from 'react-redux';
import { State } from 'store/types';
import View from './View';


const mapStateToProps = (state: State) => {
  const { remoteConfig } = state;
  return {
    internationalMode: remoteConfig?.switches.internationalMode,
    freeShipping: remoteConfig?.configs.freeShipping,
    featuresEnabled: remoteConfig?.switches.featuresEnabled,
    features: remoteConfig?.configs.features,
  };
};

export default connect(mapStateToProps)(View);
